import React, { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext(null);

function tokenKey(role)  { return role === 'tenant' ? 'rf_tenant_token' : 'rf_token'; }
function userKey(role)   { return role === 'tenant' ? 'rf_tenant_user'  : 'rf_user';  }

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    try {
      // Prefer landlord session; fall back to tenant session
      const stored = localStorage.getItem('rf_user') || localStorage.getItem('rf_tenant_user');
      return stored ? JSON.parse(stored) : null;
    } catch {
      return null;
    }
  });

  const login = (token, userData) => {
    const role = userData.role;
    localStorage.setItem(tokenKey(role), token);
    localStorage.setItem(userKey(role),  JSON.stringify(userData));
    setUser(userData);
  };

  const logout = () => {
    const role = user?.role;
    localStorage.removeItem(tokenKey(role));
    localStorage.removeItem(userKey(role));
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, isLandlord: user?.role === 'landlord', isTenant: user?.role === 'tenant' }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
